const firebaseConfig = {
  apiKey: "AIzaSyAuyrEzgvHeMXPRXv1-q9ET9HpNVmo9yxw",
  authDomain: "gears-dcddf.firebaseapp.com",
  projectId: "gears-dcddf",
  storageBucket: "gears-dcddf.appspot.com",
  messagingSenderId: "962055853657",
  appId: "1:962055853657:web:83439463a5ce50a5618348"
};

export default firebaseConfig;